import { Switch as MUISwitch, FormControlLabel } from '@mui/material';
import './AgSwitch.scss';

interface SwitchProps {
    label?: string;
    onChange(): void;
    defaultChecked?: boolean;
}

export function AgSwitch({ label, onChange, defaultChecked }: SwitchProps) {
    return (
        <FormControlLabel
            classes={{
                root: 'AgSwitch',
                label: 'AgSwitch__label',
            }}
            className="AgSwitch__label"
            sx={{ margin: 0 }}
            control={
                <MUISwitch
                    classes={{
                        root: 'AgSwitch__root',
                        thumb: 'AgSwitch__thumb',
                        switchBase: 'AgSwitch__base',
                        track: 'AgSwitch__track',
                        checked: 'AgSwitch--checked',
                        input: 'AgSwitch__input',
                    }}
                    defaultChecked={defaultChecked}
                    onChange={onChange}
                    disableRipple
                />
            }
            label={label}
        />
    );
}
